export function initBackToTop() {
	const btn = document.getElementById('btn-back-top');
	if (!btn) return;

	btn.addEventListener('click', () => {
		const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
		window.scrollTo({ top: 0, behavior });
	});
}
